
export default [{
  title: '品牌榜',
  list: [{
    title: '主榜单',
    name: 'main',
    value: 'BRAND-all',
    colunms: 'brandColunms'
  }, {
    title: '品类榜单',
    list: [{
      title: 'SUV',
      name: 'brandSuv',
      value: 'BRAND-product-SUV',
      colunms: 'brandColunms'
    }, {
      title: '轿车',
      name: 'brandCar',
      value: 'BRAND-product-轿车',
      colunms: 'brandColunms'
    }, {
      title: '跑车',
      name: 'brandSportSedan',
      value: 'BRAND-product-轿跑',
      colunms: 'brandColunms'
    }, {
      title: 'MPV',
      name: 'brandMPV',
      value: 'BRAND-product-MPV',
      colunms: 'brandColunms'
    }]
  }, {
    title: '车系榜单',
    list: [{
      title: '德系',
      name: 'brandGermany',
      value: 'BRAND-series-德系',
      colunms: 'brandColunms'
    }, {
      title: '日系',
      name: 'brandJapan',
      value: 'BRAND-series-日系',
      colunms: 'brandColunms'
    }, {
      title: '韩系',
      name: 'brandKorea',
      value: 'BRAND-series-韩系',
      colunms: 'brandColunms'
    }, {
      title: '欧系',
      name: 'brandEurope',
      value: 'BRAND-series-欧系',
      colunms: 'brandColunms'
    }, {
      title: '美系',
      name: 'brandUS',
      value: 'BRAND-series-美系',
      colunms: 'brandColunms'
    }, {
      title: '自主',
      name: 'brandAutonomously',
      value: 'BRAND-series-自主',
      colunms: 'brandColunms'
    }]
  }]
}, {
  title: '产品榜',
  list: [{
    title: 'SUV',
    name: 'productSUV',
    value: 'PRODUCT-SUV',
    colunms: 'productColunms'
  }, {
    title: '轿车',
    name: 'productCar',
    value: 'PRODUCT-轿车',
    colunms: 'productColunms'
  }, {
    title: '跑车',
    name: 'productSportSedan',
    value: 'PRODUCT-轿跑',
    colunms: 'productColunms'
  }, {
    title: 'MPV',
    name: 'productMPV',
    value: 'PRODUCT-MPV',
    colunms: 'productColunms'
  }, {
    title: '新能源',
    name: 'productNew',
    value: 'PRODUCT-新能源',
    colunms: 'productColunms'
  }]
}, {
  title: '消费榜',
  list: [{
    title: '不同年龄阶段榜单',
    list: [{
      title: '70前',
      name: 'customeBefore70',
      value: 'CONSUME-age-70前',
      colunms: 'ageColunms'
    }, {
      title: '70后',
      name: 'customeAfter70',
      value: 'CONSUME-age-70后',
      colunms: 'ageColunms'
    }, {
      title: '80后',
      name: 'customeAfter80',
      value: 'CONSUME-age-80后',
      colunms: 'ageColunms'
    }, {
      title: '90后',
      name: 'customeAfter90',
      value: 'CONSUME-age-90后',
      colunms: 'ageColunms'
    }, {
      title: '95后',
      name: 'customeAfter95',
      value: 'CONSUME-age-95后',
      colunms: 'ageColunms'
    }, {
      title: '00后',
      name: 'customeAfter00',
      value: 'CONSUME-age-00后',
      colunms: 'ageColunms'
    }]
  }, {
    title: '不同性别榜单',
    list: [{
      title: '男',
      name: 'customeSexMan',
      value: 'CONSUME-gender-1',
      colunms: 'customeColunms'
    }, {
      title: '女',
      name: 'customeSexWoman',
      value: 'CONSUME-gender-0',
      colunms: 'customeColunms'
    }]
  }]
}, {
  title: '科技榜',
  list: [{
    title: '造车新势⼒',
    name: 'sciencePower',
    value: 'SCIENCE-0',
    colunms: 'brandColunms'
  }, {
    title: '新能源汽车',
    name: 'scienceEnergy',
    value: 'SCIENCE-1',
    colunms: 'brandColunms'
  }]
}, {
  title: '豪华品牌',
  name: 'brandLuxury',
  value: 'BRAND-product-豪华品牌',
  colunms: 'brandColunms'
}]


// WEBPACK FOOTER //
// src/routes/soumi/typeList.js